import React, {Component} from 'react';
import PropTypes from 'prop-types';

export class ViewerCode extends Component {

    static propTypes = {
        events: PropTypes.object.isRequired
    }

    state = {};

    render() {
        return <div>
            code here!
        </div>
    }
}

export default ViewerCode;
